// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import { configureInternalNavigationFromCMSUrl, getViewportInfo } from '@tcp/core/src/utils';
import Recommendations from '@tcp/core/src/components/common/molecules/Recommendations';
import RecommendationsConstants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import Notification from '@tcp/core/src/components/common/molecules/Notification/index';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { globalCommonBrowseLabels } from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { globalErrorMessagesLabels } from '@tcp/core/src/utils/labels/globalErrorMessages.labels';
import {
  InterimSoldOut,
  CategoryNameDiv,
  AnchorStyle,
  DepartmentMsgDiv,
  ContainerDiv,
  SectionGap,
} from '../styles/EmptyCategoryPage.style';
import BopisFilterEmptyResults from '../../BopisFilterEmptyPage';

const returnAnchor = ({ navTree, labelForSplit }) => {
  const departmentText = !!labelForSplit[1] && labelForSplit[1].split('#');
  return (
    <DepartmentMsgDiv className="department-msg">
      {!!departmentText[0] && departmentText[0]}
      {navTree && navTree.categoryContent && navTree.categoryContent.asPath && (
        <AnchorStyle
          className={'department-url'}
          asPath={navTree.categoryContent.asPath}
          to={
            navTree.categoryContent.asPath &&
            configureInternalNavigationFromCMSUrl(navTree.categoryContent.asPath)
          }
        >
          {!!departmentText[1] && `${departmentText[1]}`}
        </AnchorStyle>
      )}
      {!!departmentText[2] && `${departmentText[2]}!`}
    </DepartmentMsgDiv>
  );
};

const showCategoryAndDepartment = (interimSoldout, deptName, catName) => {
  let newInterimSoldout = interimSoldout.replace('<Department Name>', deptName?.toLowerCase());
  newInterimSoldout = newInterimSoldout.replace('<Category Name>', catName);
  return newInterimSoldout;
};

const returnDeptName = (checkBreadCrumbAvailability, breadCrumbs) => {
  return checkBreadCrumbAvailability && breadCrumbs[1].displayName;
};

const returnCategoryName = (checkBreadCrumbAvailability, breadCrumbs) => {
  const catName = checkBreadCrumbAvailability && breadCrumbs[breadCrumbs.length - 1].displayName;
  return catName || '';
};

const departmentNameCheck = (department) => {
  return department ? department.toUpperCase() : '';
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const EmptyCategoryPage = (props) => {
  const globalBrowseLabels = getLabelFromCopyOrFromTranslation(
    'global.CommonBrowseLabels',
    globalCommonBrowseLabels
  );
  const interimSoldoutLabel = getDynamicLabelValues(
    'dynamic.browse_d.lbl_category_interimSoldout_web'
  );

  const internalServerError = getLabelFromCopyOrFromTranslation(
    'global.errorMessages.lbl_errorMessages_INTERNAL_SERVER_ERROR',
    globalErrorMessagesLabels
  );

  const plpAvailableShiptoHome = renderLabel(
    globalBrowseLabels.lbl_plp_available_ship,
    'lbl_plp_available_ship'
  );
  const {
    navTree,
    className,
    breadCrumbs,
    isBopisFilterOn,
    isServiceError,
    isHPLP,
    isPlp,
    pathName,
    isPLPSortAndOneHrFilterRedesignEnabled,
  } = props;
  const { isDesktop } = getViewportInfo();
  const checkBreadCrumbAvailability = breadCrumbs && breadCrumbs[1] && breadCrumbs[1].displayName;
  const showNewBopisFilterEmptyMessage = isBopisFilterOn;
  const pluralMapping = {
    'TODDLER GIRL': 'Toddler Girls',
    'TODDLER BOY': 'Toddler Boys',
    'Family Shop': 'Family Shops',
    'Uniform Shop': 'Uniform Shops',
    GIRL: 'Girls',
    BOY: 'Boys',
  };

  let departmentName = returnDeptName(checkBreadCrumbAvailability, breadCrumbs);
  const categoryName = returnCategoryName(checkBreadCrumbAvailability, breadCrumbs);
  const dept = departmentName;
  if (dept in pluralMapping) {
    departmentName = pluralMapping[dept];
  }
  departmentName = departmentNameCheck(departmentName);
  const interimSoldout = interimSoldoutLabel
    ? showCategoryAndDepartment(interimSoldoutLabel, departmentName, categoryName)
    : '';
  const labelForSplit = interimSoldout ? interimSoldout.split('?') : '';

  const recommendationAttributes = {
    variations: 'moduleO',
    page: RecommendationsConstants.RECOMMENDATIONS_PAGES_MAPPING.NULL_SEARCH,
    showLoyaltyPromotionMessage: false,
    headerAlignment: 'left',
  };

  return (
    <>
      {isServiceError ? (
        <ContainerDiv className={className}>
          <Notification isError status="error" message={internalServerError} />
        </ContainerDiv>
      ) : (
        <ContainerDiv className={className} isHPLP={isHPLP}>
          {showNewBopisFilterEmptyMessage ? (
            <>
              {isDesktop && (
                <>
                  <BopisFilterEmptyResults
                    className={className}
                    isPlp={isPlp}
                    pathName={pathName}
                    isPLPSortAndOneHrFilterRedesignEnabled={isPLPSortAndOneHrFilterRedesignEnabled}
                  />
                </>
              )}
              <SectionGap height={36} />
              <div className="recommendation-wrapper">
                <Recommendations
                  headerLabel={plpAvailableShiptoHome}
                  portalValue={RecommendationsConstants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED}
                  sequence="2"
                  isNoResponseRecommendation={true}
                  {...recommendationAttributes}
                  isNewPlp
                />
              </div>
            </>
          ) : (
            <InterimSoldOut className={'interim-sold-out'}>
              <CategoryNameDiv className={'category-name'}>
                {`${!!interimSoldout && interimSoldout.split('?')[0].toUpperCase()}?`}
              </CategoryNameDiv>
              {returnAnchor({ navTree, labelForSplit })}
            </InterimSoldOut>
          )}
        </ContainerDiv>
      )}
    </>
  );
};

EmptyCategoryPage.propTypes = {
  className: PropTypes.string,
  navTree: PropTypes.shape({}),
  breadCrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  isBopisFilterOn: PropTypes.bool,
  isServiceError: PropTypes.bool,
  isHPLP: PropTypes.bool,
};

EmptyCategoryPage.defaultProps = {
  navTree: {},
  className: '',
  breadCrumbs: [],
  isBopisFilterOn: false,
  isServiceError: false,
  isHPLP: false,
};
export default EmptyCategoryPage;
